<script>
    import { mapState } from "vuex";
    import { formatPrice } from "@/utils";
    import { FREE_DELIVERY_LIMIT } from "@/settings/constants";

    export default {
        name: "HomeAdvantages",
        computed: {
            ...mapState("Root", {
                freeDeliveryCount: (state) => state.site.freeDelivery,
            }),
            hasFreeDelivery() {
                return this.freeDeliveryCount < FREE_DELIVERY_LIMIT;
            },
            list() {
                const list = [
                    { name: "Гарантия 1&nbsp;год", icon: "guarantee" },
                    { name: "Заботливый клиентский сервис", icon: "service" },
                    { name: "100% подлинность всех изделий", icon: "identity" },
                ];
                if (this.hasFreeDelivery) {
                    list.push({
                        name: `Бесплатная доставка от&nbsp;<nobr>${formatPrice(
                            this.freeDeliveryCount
                        )}&nbsp;₽</nobr>`,
                        icon: "delivery",
                    });
                }

                return list;
            },
        },
    };
</script>

<template>
    <div class="home-advantages" :class="{ 'is-limited': !hasFreeDelivery }">
        <div class="home-advantages__item" v-for="(item, index) in list" :key="index">
            <img
                class="home-advantages__icon"
                :src="`/static/bivan/assets/home/advantages/${item.icon}.svg`"
                :alt="item.name"
            />
            <span v-html="item.name"></span>
        </div>
    </div>
</template>

<style lang="scss">
    .home-advantages {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding: 20px 0 40px;
        &.is-limited {
            @include bp_max($bp-desktop-sm_max) {
                display: block;
                .home-advantages__item {
                    display: flex;
                    align-items: center;
                    max-width: 100%;
                    padding-bottom: 12px;
                }
                .home-advantages__icon {
                    @include box(50px);
                    margin: 0 10px 0 0;
                }
            }
        }
    }

    .home-advantages__item {
        flex-basis: 50%;
        max-width: 50%;
        padding: 0 8px 24px;
        color: var(--secondary-text);
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        @include bp($bp-desktop-sm) {
            display: flex;
            align-items: center;
            flex-basis: 25%;
            max-width: 25%;
            padding: 0 27px;
            font-size: 16px;
            line-height: 20px;
            text-align: left;
        }
    }

    .home-advantages__icon {
        @include box(70px);
        margin: 0 auto 4px;
        @include bp($bp-desktop-sm) {
            @include box(80px);
            margin: 0 12px 0 0;
        }
    }
</style>
